export default __webpack_public_path__ + "info-one-click-assign@2x.png";